<script>
export default {
    methods: {
        formatPrice(price) {
            let val = Math.round(price*100)/100;
            return val.toFixed(2);
        },
        getPriceValue(turnaround) {
            if(!turnaround) {
                turnaround = this.SelectedData.turnaround;
            }
            if(turnaround) {
                if(this.SelectedData.expertise == 'Certified') {
                    return parseFloat(turnaround.PriceCertified);
                } else {
                    return parseFloat(turnaround.PriceRegular);
                }  
            }
            return false;
        },
        getMinPriceValue(turnaround) {
            if(!turnaround) {
                turnaround = this.SelectedData.turnaround;
            }
            if(turnaround) {
                if(this.SelectedData.expertise == 'Certified') {
                    return parseFloat(turnaround.MinCertified);
                } else {
                    return parseFloat(turnaround.MinRegular);
                }  
            }
            return false;
        },
        getBasicPrice(turnaround) {
            if(!turnaround) {
                turnaround = this.SelectedData.turnaround;
            }
            if(turnaround && this.SelectedData.numberWords > 0) {
                return this.formatPrice(this.SelectedData.numberWords*this.getPriceValue(turnaround));
            }
        },
        checkMinimalAmount(amount, turnaround) {
            if(!turnaround) {
                turnaround = this.SelectedData.turnaround;
            }
            const minAmount = this.getMinPriceValue(turnaround);
            this.SelectedData.totalBeforeMinAmount = amount;
            if (amount < minAmount) {
                this.SelectedData.minAmountUsed = true;
                return minAmount;
            }
            if(this.SelectedData.minAmountUsed == 'flat') {
                this.SelectedData.minAmountUsed = true;
            } else {
                this.SelectedData.minAmountUsed = false;
            }
            return amount;
        },
        getTotalByTurnaround(turnaround) {
            if(!turnaround) {
                turnaround = this.SelectedData.turnaround;
            }
            let amount = this.getBasicPrice(turnaround);
            amount = this.checkMinimalAmount(amount, turnaround);
            let total = amount;

            let totalOption = this.getOvernightOption(total, turnaround);
            if (totalOption) {
                total = totalOption.total;
            }

            // 7/5 dollar credit
            totalOption = this.getCreditOption(total, turnaround);
            if (totalOption) {
                total = totalOption.total;
            }

            totalOption = this.getCouponOption(total, turnaround);
            if (totalOption) {
                total = totalOption.total;
            }
            return total;
        },
        getTotalOptions(amount, turnaround, upgrade, noholiday) {
            if(!turnaround) {
                turnaround = this.SelectedData.turnaround;
            }
            const totalOptions = [];
            let total = amount;
            if(!upgrade) {
                this.SelectedData.totalBeforeMinAmount = amount;
            }

            let totalOption = this.getOvernightOption(total, turnaround);
            if (totalOption) {
                totalOptions.push(totalOption);
                total = totalOption.total;
            }
            // 7/5 dollar credit
            totalOption = this.getCreditOption(total, turnaround);
            if (totalOption) {
                totalOptions.push(totalOption);
                total = totalOption.total;
            }


            totalOption = this.getCouponOption(total, turnaround);
            if (totalOption) {
                totalOptions.push(totalOption);
                total = totalOption.total;
            }

            return totalOptions;
        },
        getOvernightOption(amount, turnaround) {
            if (turnaround.OvernightAllowed) {
                const total = this.percentbasedAmount(
                    parseFloat(turnaround.OvernightPrice),
                    amount,
                    '+'
                );
                const diff = total - amount;
                const ret = {};
                ret.amount = diff.toFixed(2);
                ret.sign = '+';
                ret.label = 'Overnight Surcharge';
                ret.total = total;
                return ret;
            }
            return false;
        },
        getCreditOption(amount, turnaround) {
            console.log(this.accountData);
            if (this.accountData?.Credit > 0) {
                let credit = this.accountData.Credit;
                credit = parseFloat(credit);
                credit /= 100;
                const total = amount - credit;
                const ret = {};
                ret.amount = credit.toFixed(2);
                ret.sign = '-';
                ret.label = '$' + credit + ' Credit';
                ret.total = total.toFixed(2);
                return ret;
            }
            return false;
        },
        getCouponOption(amount, turnaround) {
            if (this.SelectedData.couponData.couponCode) {
                let message = '';
                let total = this.getCouponTotal(amount);
                const diff = amount - total;
                const ret = {};
                ret.amount = diff.toFixed(2);
                ret.message = message;
                ret.sign = '-';
                const ruleAmount = parseFloat(this.SelectedData.couponData.ruleAmount);
                const ruleType = this.SelectedData.couponData.couponRule;
                const labelSufix = this.getPercentFixedSufix(ruleAmount,ruleType);
                ret.label = labelSufix + ' Coupon';
                ret.total = total;
                return ret;
            }
            return false;
        },
        getCouponTotal(amount) {
            const ruleAmount = parseFloat(this.SelectedData.couponData.ruleAmount);
            const ruleType = this.SelectedData.couponData.couponRule;
            const total = this.getCouponDicountTotalvalue(ruleAmount, ruleType, amount);
            return total;
        },
        getCouponDicountTotalvalue(ruleAmount, ruleType, amount) {
            let total = '';
            if (ruleType == 'Percent discount' || ruleType == 'Percent Discount') {
                total = this.percentbasedAmount(
                    ruleAmount,
                    amount,
                    '-'
                );
            } else {
                total = amount - ruleAmount;
                total = total.toFixed(2);
            }
            return total;
        },
        percentbasedAmount(percent, price, addSub) {
            percent = parseFloat(percent); 
            let amount = 0;
            if (addSub == '+') {
                amount = price * ((100 + percent) / 100);
            } else {
                amount = price * ((100 - percent) / 100);
            }
            //this.bestDealPrice(amount);
            amount = amount.toFixed(2);
            return amount;
        },
        getPercentFixedSufix(ruleAmount,ruleType) {
            if(ruleType == 'Percent discount' || ruleType == 'Percent Discount') {
                return ruleAmount+'%';
            }
            return '$'+ruleAmount;
        },
    }
}
</script>